export function previewKind(kind) {
  if (kind === 'html') return 'html'
  if (kind === 'markdown') return 'markdown'
  if (kind === 'pdf' || kind === 'pptx' || kind === 'docx' || kind === 'xlsx' || kind === 'csv') return 'pdf'
  return 'doc'
}

export function previewPayload(kind, url) {
  if (kind === 'html') return { html: '', url }
  if (kind === 'markdown') return { url }
  if (kind === 'pdf') return { url }
  return { sections: [] }
}

export function cleanTitle(title) {
  return String(title || 'Generated artifact').split(/[\\/]/).pop() || 'Generated artifact'
}

export function kindLabel(kind, sizeLabel) {
  const label = String(kind ?? 'artifact').toUpperCase()
  return sizeLabel ? `${label} · ${sizeLabel}` : label
}

export function artifactContextTitle(kind) {
  if (kind === 'pdf' || kind === 'pptx') return 'Created report'
  return 'Created artifact'
}
